import { ComponentNavPages } from './pages/ComponentNavPage';
import { TextAccordionCategory } from './cookbook-ui/custom-components/TextAccordion/TextAccordion.model';

export const pages: TextAccordionCategory[] = [
  {
    title: 'Introduction',
    id: '1000',
    containsIds: ['FAQ_0', 'FAQ_1', 'FAQ_2'],
    items: [
      {
        title: 'Home',
        href: '/',
        id: 'section-home',
      },
      {
        title: "FAQ's",
        href: '/FAQ',
        id: 'section-faq',
      },
      {
        title: 'DebugService',
        href: '/DebugService',
        id: 'section-debug-service',
      },
      {
        title: 'Updates',
        href: '/Updates',
        id: 'section-updates',
      },
      {
        title: 'Upcoming Breaking Changes',
        href: '/Upcoming-Breaking-Changes',
        id: 'section-ubc',
      },
      {
        title: 'Metrics',
        href: '/Metrics',
        id: 'section-metrics',
      },
    ],
  },
  // {
  //   title: 'Patterns',
  //   id: '8000',
  //   containsIds: [],
  //   items: []
  // },
  {
    title: 'Visuals',
    id: '2000',
    containsIds: [
      'Colors_0',
      'Colors_1',
      'Colors_2',
      'Colors_3',
      'Colors_4',
      'Graphics_0',
      'Graphics_1',
      'Icons_0',
      'Icons_1',
      'Icons_2',
      'Shadows_0',
      'Shadows_1',
      'Shadows_2',
      'Shadows_3',
      'Typography_0',
      'Typography_1',
      'Typography_2',
      'Typography_3',
      'Typography_4',
    ],
    items: [
      {
        title: 'Colors',
        href: '/Colors',
        id: 'section-colors',
        containsIds: ['Colors_0', 'Colors_1', 'Colors_2', 'Colors_3'],
        sections: [
          {
            title: 'Colors',
            href: '/Colors#Colors',
            id: 'Colors_0',
          },
          {
            title: 'Specific Colors',
            href: '/Colors#Specific-Colors',
            id: 'Colors_1',
          },
          {
            title: 'Gradients',
            href: '/Colors#Gradients',
            id: 'Colors_2',
          },
          {
            title: 'Accessing Colors',
            href: '/Colors#Accessing-Colors',
            id: 'Colors_3',
          },
        ],
      },
      {
        title: 'Graphics',
        href: '/Graphics',
        id: 'section-graphics',
        containsIds: ['Graphics_0', 'Graphics_1', 'Graphics_2', 'Graphics_3', 'Graphics_4', 'Graphics_5', 'Graphics_6', 'Graphics_7', 'Graphics_8'],
        sections: [
          {
            title: 'Animations',
            href: '/Graphics#Animations',
            id: 'Graphics_0',
          },
          {
            title: 'Illustrations',
            href: '/Graphics#Illustrations',
            id: 'Graphics_1',
          },
          {
            title: 'InMoment Logos',
            href: '/Graphics#InMoment-Logos',
            id: 'Graphics_2',
          },
          {
            title: 'Skewmorphics',
            href: '/Graphics#Skewmorphics',
            id: 'Graphics_3',
          },
          {
            title: 'Visual Demos',
            href: '/Graphics#Visual-Demos',
            id: 'Graphics_4',
          },
          {
            title: 'Sentiments',
            href: '/Graphics#Sentiments',
            id: 'Graphics_5',
          },
          {
            title: 'Backgrounds',
            href: '/Graphics#Backgrounds',
            id: 'Graphics_6',
          },
          {
            title: 'Company Logos',
            href: '/Graphics#Company-Logos',
            id: 'Graphics_7',
          },
          {
            title: 'Misc SVGs',
            href: '/Graphics#Misc-SVGs',
            id: 'Graphics_8',
          },
        ],
      },
      // {
      //   title: 'Grid',
      //   href: '/Grid'
      // },
      {
        title: 'Icons',
        href: '/Icons',
        containsIds: ['Icons_0', 'Icons_1', 'Icons_2'],
        id: 'section-icons',
        sections: [
          {
            title: 'App Icons',
            href: '/Icons#App-Icons',
            id: 'Icons_0',
          },
          {
            title: 'XI Icons',
            href: '/Icons#XI-Icons',
            id: 'Icons_1',
          },
          {
            title: 'Modifying Color',
            href: '/Icons#Modifying-Color',
            id: 'Icons_2',
          },
        ],
      },
      {
        title: 'Shadows',
        href: '/Shadows',
        containsIds: ['Shadows_0', 'Shadows_1', 'Shadows_2', 'Shadows_3'],
        id: 'section-shadows',
        sections: [
          {
            title: 'XIShadowsDown',
            href: '/Shadows#XIShadowsDown',
            id: 'Shadows_0',
          },
          {
            title: 'XIShadowsLeft',
            href: '/Shadows#XIShadowsLeft',
            id: 'Shadows_1',
          },
          {
            title: 'XIShadowsRight',
            href: '/Shadows#XIShadowsRight',
            id: 'Shadows_2',
          },
          {
            title: 'XIShadowsUp',
            href: '/Shadows#XIShadowsUp',
            id: 'Shadows_3',
          },
        ],
      },
      {
        title: 'Typography',
        href: '/Typography',
        id: 'section-typography',
        containsIds: ['Typography_0', 'Typography_1', 'Typography_2'],
      },
    ],
  },
  // {
  //   title: 'Templates',
  //   id: '4000',
  //   containsIds: ['section-refApp', 'section-starter'],
  //   items: [
  //     {
  //       title: 'Reference App',
  //       href: '/Reference-App',
  //       id: 'section-refApp'
  //     },
  //     {
  //       title: 'Kitchen Starter',
  //       href: '/Kitchen-Starter',
  //       id: 'section-starter'
  //     }
  //   ]
  // },
  ComponentNavPages,
];
